"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddProductSearchInput = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _useTranslations = require("../../../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const AddProductSearchInput = (param)=>{
    let { isError, onInputReset, onChange } = param;
    const { translations } = (0, _useTranslations.useTranslations)();
    const { register } = (0, _reactHookForm.useFormContext)();
    const productCode = (0, _reactHookForm.useWatch)({
        name: 'productCode'
    });
    const inputProps = (0, _react.useMemo)(()=>({
            startAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.InputAdornment, {
                position: "start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Search, {})
            }),
            endAdornment: productCode ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.InputAdornment, {
                position: "end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ClearIconButton, {
                    variant: "text",
                    "aria-label": translations.clearSearchField,
                    onClick: onInputReset,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Clear, {})
                })
            }) : null
        }), [
        onInputReset,
        translations.clearSearchField,
        productCode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.SearchInput, {
        ...register('productCode', {
            onChange
        }),
        autoFocus: true,
        color: isError ? 'error' : 'primary',
        variant: "filled",
        placeholder: translations.searchDefaultText,
        InputProps: inputProps
    });
};
exports.AddProductSearchInput = AddProductSearchInput;
